import { BaggingApiRepository } from "@/app/infrastructures/repositories/api/BaggingApiRepository";
import { injectable } from "tsyringe";
import {
  BaggingDisputeSummaryRequestInterface,
  BaggingToReadyToCargoRequestInterface,
  ChangeBaggingRequestInterface,
  UpdateBaggingInterface
} from "@/data/payload/contracts/BaggingRequest";
import {
  BaggingDataDetail,
  BaggingDisputeSummary,
  BaggingEntities,
  BaggingSttList,
  RegionBaggingGrouping
} from "@/domain/entities/Bagging";
import { ResponsePayload, ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";
import { BaggingDisputeSummaryRequest, BaggingListRequest } from "@/data/payload/api/BaggingApiRequest";

@injectable()
export class BaggingPresenter {
  private repository: BaggingApiRepository;

  constructor(repository: BaggingApiRepository) {
    this.repository = repository;
  }

  public getListBagging(params: BaggingListRequest): Promise<BaggingEntities> {
    return this.repository.getListBagging(params);
  }

  public getDetailBagging(id: number): Promise<BaggingDataDetail> {
    return this.repository.getDetailBagging(id);
  }

  public getDetailSttNumber(
    sttNumber: string,
    partnerId?: number
  ): Promise<BaggingSttList> {
    return this.repository.getDetailSttNumber(sttNumber, partnerId);
  }

  public async generateBagging(
    payload: ChangeBaggingRequestInterface
  ): Promise<ResponsePayload> {
    return this.repository.createBagging(payload);
  }

  public updateBagging(
    payload: UpdateBaggingInterface
  ): Promise<ResponsePayload> {
    return this.repository.updateBagging(payload);
  }

  public async downloadBagging(data: any): Promise<any> {
    return this.repository.downloadBagging(data);
  }

  public getRegionBaggingGrouping(
    code: string
  ): Promise<RegionBaggingGrouping> {
    return this.repository.getRegionBaggingGrouping(code);
  }

  public updateBaggingToReadyToCargo(payload: BaggingToReadyToCargoRequestInterface): Promise<ResponsePayloadV2> {
    return this.repository.updateBaggingToReadyToCargo(payload);
  }

  public getBaggingDisputeSummary(params: BaggingDisputeSummaryRequest): Promise<BaggingDisputeSummary> {
    return this.repository.getBaggingDisputeSummary(params);
  }

  public downloadBaggingDisputeSummary(payload: any): Promise<any> {
    return this.repository.downloadBaggingDisputeSummary(payload);
  }
}
